export function formatMessage(msg) {
    let m = `[${msg.severity}] ${msg.data}`;
    if (msg.loggerName) {
        m = `[${msg.loggerName}] ${m}`;
    }
    const date = msg.date.replace(/T/, ' ').replace(/\..+/, '');
    m = `[${date}] ${m}`;
    return m;
}
